import { render, staticRenderFns } from "./FacilityIncidentsList.vue?vue&type=template&id=358b58bc&scoped=true&"
import script from "./FacilityIncidentsList.vue?vue&type=script&lang=js&"
export * from "./FacilityIncidentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b58bc",
  null
  
)

export default component.exports